import { Spinner } from '@fluentui/react';
import * as React from 'react';
import * as Styled from './Loading.styled';
import { ILoadingProps } from './Loading.types';

export function Loading(props: ILoadingProps): React.ReactElement {
    return (
        <Styled.Loading>
            <Spinner ariaLabel={props.label} label={props.label} ariaLive="assertive" labelPosition="top" />
        </Styled.Loading>
    );
}
